module.exports = __webpack_public_path__ + "img/register-logo.eb8daf51.png";